import React from 'react';
import {Dropdown} from "react-bootstrap";
import {Link} from "react-router-dom";
import TextTranslate from '../TextTranslate/TextTranslate';

import "./invitationstatus.scss";


const InvitationStatus = ({selected = 'yes'}) => {

    let options = {
        yes: <TextTranslate name="invitation-confirm-attend" fallback="Yes, I will be attending"/>,
        no: <TextTranslate name="invitation-decline-attend" fallback="No, I will not be attending"/>,
    };

    return (
        <form>
            <div className="invitation-status form-group mb-0">
                <label className="form-label">
                    <TextTranslate name="invitation-status" fallback="Invitation Status" textOnly/>
                </label>
                <Dropdown>
                    <Dropdown.Toggle size="sm" variant="dropdown">
                        {options[selected]}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Link className="dropdown-item" to="/decline">
                            {options.no}
                        </Link>
                        <Link className="dropdown-item" to="/confirm">
                            {options.yes}
                        </Link>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </form>
    );
};

export default InvitationStatus;
